import { format, parse } from "date-fns";

export function formatBirthDate(input: string): string {
  // 1. 숫자만 남기고 제거
  const onlyNumbers = input.replace(/[^0-9]/g, "");
  // 2. 8자리가 아니면 그대로 반환
  if (onlyNumbers.length !== 8) return input;
  // 3. 0000-00-00 형식으로 변환
  return `${onlyNumbers.slice(0, 4)}-${onlyNumbers.slice(
    4,
    6
  )}-${onlyNumbers.slice(6, 8)}`;
}

export function formatTime(input: string): string {
  if (input.includes("???")) return "20:30";
  // 숫자 4자리만 남기고, 4자리가 아니면 그대로 반환
  const onlyNumbers = input.replace(/[^0-9]/g, "");
  if (onlyNumbers.length !== 4) return input;
  return `${onlyNumbers.slice(0, 2)}:${onlyNumbers.slice(2, 4)}`;
}

export const getYMDString = (date: Date): string => {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1.
  const dd = String(date.getDate()).padStart(2, "0");

  // Return as "YYYYMMDD" string
  return `${yyyy}${mm}${dd}`;
};

export function getHMString(date: Date): string {
  let hours: any = date.getHours();
  let minutes: any = date.getMinutes();

  // Convert to 24-hour format
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;

  // Return as "HHMM" string
  return `${hours}${minutes}`;
}

export function formatDatetoKoreanDate(dateString: string) {
  const parts = dateString.split("-");

  // if (parts.length !== 3) {
  //   throw new Error("Invalid date format");
  // }

  return `${parts[0]}년 ${parts[1]}월 ${parts[2]}일`;
}

export function formatDateWithDash(dateString: string) {
  // '19970125' 형식의 문자열을 '1997-01-25'로 변환
  const parsedDate = parse(dateString, "yyyyMMdd", new Date());
  return format(parsedDate, "yyyy-MM-dd");
}
export function formatTimeWithColon(timeString: string) {
  // '1000' 형식의 문자열을 '10:00'으로 변환
  const parsedTime = parse(timeString, "HHmm", new Date());
  return format(parsedTime, "HH:mm");
}
export const convertTimeString = (time: string | null): string | null => {
  if (time === null) {
    return null;
  }

  // Remove the ":" from the time string
  return time.replace(":", "");
};
export const convertDateString = (date: string | null): string | null => {
  if (date === null) {
    return null;
  }

  // Remove the "-" from the date string
  return date.replace(/-/g, "");
};

export const formatDate = (date: string): string => {
  if (date.length !== 8) {
    // throw new Error(
    //   "Invalid date format. The date string should be in YYYYMMDD format."
    // );
    return "";
  }

  const yyyy = date.substring(0, 4);
  const mm = date.substring(4, 6);
  const dd = date.substring(6, 8);

  return `${yyyy}년 ${mm}월 ${dd}일`;
};

export function parseDateString(dateString: string) {
  const yearMatch = dateString.match(/\d{4}년/);
  const monthMatch = dateString.match(/\d{1,2}월/);

  if (!yearMatch || !monthMatch) {
    throw new Error("Invalid date string format");
  }

  const year = parseInt(yearMatch[0], 10);
  const month = parseInt(monthMatch[0], 10) - 1; // 월은 0부터 시작하므로 1을 빼줍니다.

  return new Date(year, month);
}

/** 현재년도의 월을 반환하는 함수 */
export const getCurrentMonth = () => {
  const date = new Date();
  return date.getMonth() + 1; // getMonth()는 0부터 시작하므로 1을 더합니다.
};
/** 현재년도를 반환하는 함수 */
export const getCurrentYear = () => {
  const date = new Date();
  return date.getFullYear();
};

export function formatBirthday(birthday: string) {
  // 하이픈(-)이 있는 경우
  if (birthday.includes("-")) {
    return birthday.replace(/-/g, ".");
  }
  // 하이픈(-)이 없는 경우
  else if (birthday.length === 8) {
    return `${birthday.substring(0, 4)}.${birthday.substring(
      4,
      6
    )}.${birthday.substring(6, 8)}`;
  }
  // 유효하지 않은 형식
  else {
    return "Invalid date format";
  }
}

/** 음력의 표시는 1일인 경우에만 월과 일을 같이 표시하고 아닌 경우에는 날짜만 표시한다. */
export function convertLunaDate(str: string) {
  const parts = str.split(".");
  const month = parseInt(parts[1], 10);
  const day = parseInt(parts[2], 10);

  if (day === 1) {
    return `${month}.${day}`;
  } else {
    return day;
  }
}

// 입력값 포맷 함수 추가

// export function formatDateInput(value: string): string {
//   if (!value) return "";

//   const digits = value.replace(/\D/g, "").slice(0, 8);
//   const len = digits.length;

//   if (len <= 4) return digits;
//   if (len === 5) return `${digits.slice(0, 4)}/${digits.slice(4)}`;
//   if (len === 6) return `${digits.slice(0, 4)}/${digits.slice(4, 6)}`;
//   if (len === 7)
//     return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/${digits.slice(6)}`;
//   if (len === 8)
//     return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/${digits.slice(6, 8)}`;

//   return digits;
// }

export function formatDateInput(value: string): string {
  const digits = value.replace(/\D/g, "").slice(0, 8);
  const len = digits.length;

  if (len < 4) {
    return digits;
  } else if (len === 4) {
    return `${digits}/`;
  } else if (len < 6) {
    return `${digits.slice(0, 4)}/${digits.slice(4)}`;
  } else if (len === 6) {
    return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/`;
  } else {
    return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/${digits.slice(6)}`;
  }
}

// export function formatDateInput2(value: string): string {
//   const digits = value.replace(/\D/g, "").slice(0, 8);
//   const len = digits.length;

//   if (len < 4) return digits;
//   if (len <= 4) return `${digits}/`;
//   if (len < 6) return `${digits.slice(0, 4)}/${digits.slice(4)}`;
//   if (len <= 6) return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/`;

//   return `${digits.slice(0, 4)}/${digits.slice(4, 6)}/${digits.slice(6)}`;
// }
// export function formatDateInput(value: string) {
//   if (!value) return "";
//   if (value.length <= 4) return value;
//   if (value.length <= 6) return value.replace(/(\d{4})(\d{1,2})/, "$1/$2");
//   return value.replace(/(\d{4})(\d{2})(\d{1,2})/, "$1/$2/$3");
// }
export function formatTimeInput(value: string) {
  if (!value) return "";
  if (value.length <= 2) return value;
  return value.replace(/(\d{2})(\d{1,2})/, "$1:$2");
}

export function getTimeOptionValueFromHHmm(hhmm: string): string {
  if (!/^\d{4}$/.test(hhmm)) return "????";

  const hour = parseInt(hhmm.slice(0, 2), 10);
  const minute = parseInt(hhmm.slice(2), 10);
  const totalMinutes = hour * 60 + minute;

  const timeMap = [
    { value: "0030", start: 1410, end: 89 }, // 23:30~01:29
    { value: "0230", start: 90, end: 209 }, // 01:30~03:29
    { value: "0430", start: 210, end: 329 }, // 03:30~05:29
    { value: "0630", start: 330, end: 449 }, // 05:30~07:29
    { value: "0830", start: 450, end: 569 }, // 07:30~09:29
    { value: "1030", start: 570, end: 689 }, // 09:30~11:29
    { value: "1230", start: 690, end: 809 }, // 11:30~13:29
    { value: "1430", start: 810, end: 929 }, // 13:30~15:29
    { value: "1630", start: 930, end: 1049 }, // 15:30~17:29
    { value: "1830", start: 1050, end: 1169 }, // 17:30~19:29
    { value: "2030", start: 1170, end: 1289 }, // 19:30~21:29
    { value: "2230", start: 1290, end: 1409 }, // 21:30~23:29
  ];

  for (const { value, start, end } of timeMap) {
    if (start > end) {
      if (totalMinutes >= start || totalMinutes <= end) return value;
    } else {
      if (totalMinutes >= start && totalMinutes <= end) return value;
    }
  }

  return "????"; // fallback
}

/**
 * Validate YYYYMMDD date string.
 * - Must be exactly 8 digits
 * - Month 01-12
 * - Day valid for month (handles leap years)
 */
export function isValidYYYYMMDD(value: string): boolean {
  if (!/^\d{8}$/.test(value)) return false;

  const year = parseInt(value.slice(0, 4), 10);
  const month = parseInt(value.slice(4, 6), 10);
  const day = parseInt(value.slice(6, 8), 10);

  if (month < 1 || month > 12) return false;

  const isLeap = (y: number) => (y % 400 === 0 ? true : y % 100 === 0 ? false : y % 4 === 0);
  const daysInMonth = [31, isLeap(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  return day >= 1 && day <= daysInMonth[month - 1];
}

/**
 * @create 2025-08-11
 * @param time 시간
 * @return 십이시
 */
export function convertTimeToTwelveTime(time: string): string {
  // time에서 숫자를 제외한 문자 제거
  const onlyNumbers = time.replace(/[^0-9]/g, "");
  const hour = parseInt(onlyNumbers.slice(0, 2), 10);
  const minute = parseInt(onlyNumbers.slice(2), 10);
  const totalMinutes = hour * 60 + minute;

  const timeMap = [
    { key: "子時", start: 1410, end: 1409 }, //23:30~01:29
    { key: "丑時", start: 90, end: 209 }, //01:30~03:29
    { key: "寅時", start: 210, end: 329 }, //03:30~05:29
    { key: "卯時", start: 330, end: 449 }, //05:30~07:29
    { key: "辰時", start: 450, end: 569 }, //07:30~09:29
    { key: "巳時", start: 570, end: 689 }, //09:30~11:29
    { key: "午時", start: 690, end: 809 }, //11:30~13:29
    { key: "未時", start: 810, end: 929 }, //13:30~15:29
    { key: "申時", start: 930, end: 1049 }, //15:30~17:29
    { key: "酉時", start: 1050, end: 1169 }, // 17:30~19:29
    { key: "戌時", start: 1170, end: 1289 }, // 19:30~21:29
    { key: "亥時", start: 1290, end: 1409 }, // 21:30~23:29
  ];
  return (
    timeMap.find((item) => {
      if (item.start > item.end) {
        return totalMinutes >= item.start || totalMinutes <= item.end;
      } else {
        return totalMinutes >= item.start && totalMinutes <= item.end;
      }
    })?.key ?? "시간 모름"
  );
}
